module.exports = __webpack_public_path__ + "665055aaa1185f7e874461a45af718a2.png";